import script from "./BaseFiltersCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFiltersCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./BaseFiltersCheckbox.vue?vue&type=style&index=0&id=21b9dba2&scoped=true&lang=scss"

import exportComponent from "/Users/river/dev/packages/plugin-openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b9dba2"]])

export default __exports__